<template>
  <div>
    <div class="banner-wrap">
      <Banner class="pc-banner " :is-hitech="false" />
    </div>
    <Spinner v-if="!showComponent" />
    <div class="company-wrap">
      <CompanyHeader
        :constants="constants"
        :benefits="benefits"
        :selectedBenefit="selectedBenefit"
        :searchString="searchString"
        @selectCompany="selectCompany"
        @selectBenefit="selectBenefit"
      />
      <v-container v-show="showComponent" fluid px-3 class="items-wrapper">
        <div class="section_inner">
          <ArticleBreadcrumbs :items="breadCrumbs" class="pt-0" v-show="breadCrumbs.length>1"/>
          <v-row>
            <v-col cols="12" sm="12" md="9">
              <TipsWrapper
                :companies="promotedCompanies"
                :constants="promotedCompaniesConstants"
                :searchMode="searchMode"
                :searchData="searchData"
                @loadMoreCompanies="loadMoreCompanies"
                :isLoading="isLoading"
              />
              <IndustryLogos
                v-if="!searchMode"
                :companies="companiesByIndustry"
                :industries="industriesData"
                :constants="constants"
              />
            </v-col>
            <v-col cols="12" md="3" class="pt-8 hidden-sm-and-down">
              <LeftPanel />
            </v-col>
          </v-row>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import { trimStart, trimEnd } from 'lodash';
import Banner from '@/components/Jobs_List/Banner';
import CompanyHeader from '@/components/Companies/CompanyHeader';
import TipsWrapper from '@/components/Companies/TipsWrapper';
import Spinner from '@/components/Spinner/Spinner';

import IndustryLogos from '@/components/Companies/IndustryLogos';
import LeftPanel from '@/components/LeftPanel';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import { addQueryParameter } from '@/lib/urlUtils';
import { URL_LOBBY, URL_SEARCH } from '@/lib/api.js';

export default {
  name: 'companiesPage',
  mixins: [SeoOptimization],
  components: {
    Banner,
    Spinner,
    CompanyHeader,
    TipsWrapper,
    IndustryLogos,
    LeftPanel
  },

  data() {
    return {
      showComponent: false,
      searchMode: false,
      promotedCompanies: [],
      promotedCompaniesConstants: {},
      constants: {},
      benefits: [],
      industriesData: [],
      companiesByIndustry: {},
      searchData: {},
      selectedBenefit: null,
      searchString: '',
      isLoading: false,
      breadCrumbs: [],
      breadCrumbsSchema: {}
    };
  },

  async fetch() {
    const { query } = this.$route;
    const company =
      query.company && query.company.length > 0 ? query.company : null;

    let url = '';
    let searchMode = false;

    let urlQuery = '';

    if (query.benefit) {
      urlQuery = addQueryParameter(urlQuery, 'benefit', query.benefit);
    }

    if (query.industry) {
      urlQuery = addQueryParameter(urlQuery, 'industry', query.industry);
    }

    if (company != null) {
      urlQuery = addQueryParameter(urlQuery, 'company', company);
    }

    if (urlQuery.length > 0) {
      url = `${URL_SEARCH}/${urlQuery}`;
      searchMode = true;
    } else {
      url = `${URL_LOBBY}/`;
    }

    const { data } = await this.$axios.get(url);

    this.showComponent = true;
    this.searchMode = searchMode;
    this.constants = data.KeysDictionary;
    this.promotedCompaniesConstants = data.PromotedCompanyKeysDictionary;
    this.promotedCompanies = data.Companies;
    this.benefits = data.Benefits;
    this.industriesData = searchMode ? [] : data.IndustriesKeysDictionary.Keys;
    this.companiesByIndustry = searchMode ? [] : data.CompaniesByIndustries;
    this.searchData = searchMode ? data.SearchResultsKeysDictionary : {};
    this.selectedBenefit = query.benefit ? parseInt(query.benefit) : null;
    this.searchString = company ? company : '';
    this.seodata.metaData = data.SEO.MetaDataItems;
    this.seodata.pageTitle = data.SEO.title;

    this.breadCrumbs = [
      {
        name: 'home',
        value: 'דרושים',
        link: '/'
      },
      {
        name: 'companies',
        value: 'חברות מובילות',
        link: '/companies.aspx/'
      }
    ];
    this.breadCrumbsSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home page',
          item: 'https://www.drushim.co.il/'
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'חברות מובילות',
        }
      ]
    };
  },
  head() {
    return {
      // link: [{ rel: 'canonical', href: this.seodata.canonicalUrl }],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.drushim.co.il' + this.$route.fullPath
        }
      ],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.breadCrumbsSchema),
          type: 'application/ld+json'
        }
      ]
    };
  },
  mounted() {
    // run scroll to top after timeout for better performance (avoid reflow)
    window.scrollTo(0, 0);
  },
  methods: {
    selectBenefit(benefit) {
      let newRoute = this.$router.currentRoute.path;

      if (benefit && benefit > 0) {
        newRoute += '?benefit=' + benefit;
      }

      window.location = newRoute;
    },
    selectCompany(company) {
      let newRoute = this.$router.currentRoute.path;

      if (company && company.length > 0) {
        newRoute += '?company=' + company;
      }

      window.location = newRoute;
    },
    async loadMoreCompanies(url) {
      url = trimStart(url, '/');
      url = trimEnd(url, '/');

      this.isLoading = true;
      try {
        this.$nuxt.$loading.start();
        const callUrl = `${URL_SEARCH}/?${url}`;
        const { data } = await this.$axios.get(callUrl);

        this.searchMode = true;
        this.promotedCompanies = this.promotedCompanies.concat(data.Companies);
        this.searchData = data.SearchResultsKeysDictionary;
        this.$nuxt.$loading.finish();
        this.isLoading = false;
      } catch (e) {
        console.log('companies page load more');
      }
    }
  },
  watch: {
    '$route.query': '$fetch'
  }
};
</script>


<style scoped>
.company-wrap {
  min-height: 900px;
}
.items-wrapper {
  background: transparent url('/img/company_lobby_mobile_bg.jpg') top center;
  height: auto;
  background-size: contain;
  background-repeat: repeat-x;
}

.mobile-banner {
  margin: 5px;
}

@media only screen and (min-width: 600px) {
  .items-wrapper {
    background: transparent url('/img/company_lobby_pc_bg.jpg') top center
      no-repeat;
    height: auto;
  }
}
</style>
